<div *ngIf="showHeader">{{ catalogueDisplayName }} auswählen</div>

<p-dropdown
  [options]="catalogItems"
  [(ngModel)]="selectedItem"
  (onChange)="onApplySelection()"
  class="attachment-dropdown"
  [style]="{ width: '100%' }"
></p-dropdown>

<p-message *ngIf="showErrMsg" severity="warn" [text]="errMsg"></p-message>
